// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bd7e9924","513":"d15bec3d","703":"f307b7a8","787":"e2aa106f"}[chunkId] + ".chunk.js";
};